import { useEffect, useState } from 'react';
import { useSelector } from 'react-redux';
import ROUTES from '../../../constants/routes';
import qualityEvents from '../../../services/quality-events';
import renderPermissions from '../../../utils/render-permissions';
import { CLOSED_BANNER_STORAGE_VALUE, MARKETING_BAR_ACTIONS } from '../marketing-bar.constants';
import { getMarketingBarData, isSale } from '../marketing-bar.helpers';

const useMarketingBar = () => {
    const marketingBarData = getMarketingBarData();
    const [showBar, setShowBar] = useState(false);
    const permissions = renderPermissions();
    const currency = useSelector((state: RootState) => state.main.currency);
    const user = useSelector((state: RootState) => state.main.user);

    const trackEvent = (extra: MARKETING_BAR_ACTIONS) => {
        qualityEvents.track({
            extra,
            source: currentBannerId(),
            type: 'marketingBarEvent'
        });
    };

    const currentBannerId = () => {
        const { bannerId } = marketingBarData;

        return `banner:${bannerId}`;
    };

    const closeSpecialMessage = () => {
        window.storage.setItem(currentBannerId(), CLOSED_BANNER_STORAGE_VALUE);
        setShowBar(false);
        trackEvent(MARKETING_BAR_ACTIONS.CLOSED);
    };

    const handleBannerClick = () => trackEvent(MARKETING_BAR_ACTIONS.CLICKED);

    // eslint-disable-next-line react-hooks/rules-of-hooks
    useEffect(() => {
        const twentyFiveEURBannerAllowed =
            window.innerWidth > 991 &&
            currency.code === 'EUR' &&
            window.location.pathname === ROUTES.HOME.path &&
            !user.details?.totalMaterials;
        const bannersAllowed = twentyFiveEURBannerAllowed || isSale();

        if (
            bannersAllowed &&
            permissions.marketingBar &&
            marketingBarData &&
            window.storage.getItem(currentBannerId()) !== CLOSED_BANNER_STORAGE_VALUE
        ) {
            setShowBar(true);
            trackEvent(MARKETING_BAR_ACTIONS.SHOWN);
        } else {
            setShowBar(false);
        }
    }, [window.location.pathname, currency.code]);

    return {
        showBar,
        marketingBarData,
        handleBannerClick,
        closeSpecialMessage
    };
};

export default useMarketingBar;
